
<template>

    <b-container class="bv-example-row bv-example-row-flex-cols" 
    style="padding:0px;height: 100vh !important;max-width: 5000px !important;">

        <b-row style="height: 100vh;background-color: white;">
            
            <b-col xs="0" lg="6" class="d-none d-lg-block">
                <b-row style="height: 100% !important;align-content: center !important;">
                    <b-col sm="12" md="auto" style="width: 100% !important;">
                        <img height="100" src="../assets/images/logo_deskontime.png" style="margin-left: auto;margin-right: auto;display: block;padding:10px;">
                    </b-col>
                    <b-col sm="0" md="auto">
                    </b-col>
                </b-row>                
            </b-col>
            
            <b-col xs="12" lg="6" style="background: url(https://bckt-front-desk.s3.us-east-2.amazonaws.com/front-desk-wallpaper.jpg);background-repeat: no-repeat;background-size: cover;background-position: left;background-position-y: bottom;">

                    <b-row align-v="center" style="height: 100%;justify-content: center;padding: 20px !important;">
                   
                        <div style="border-radius: 5px;background-color: white;padding: 4rem 3.5rem 3rem 3.5rem;max-width: 450px;width: 100% !important;min-height: 400px;">
                            
                            <div>
                                
                                <h1 class="font-clean-title">Inicio de sesión</h1>
                                <!--<p class="font-clean-text">¿Eres un nuevo usuario? <a href="#" @click="register" :disabled="isLoading">Crear una cuenta</a></p>-->

                                <br/>

                                <form class="mb-3" @submit.prevent="signUp()">

                                    <div class="form-group">
                                        <label class="font-clean-label" style="margin-top: 0px;margin-bottom: 0px;" for="browser_first_name">Email</label>
                                    <b-form-input required v-model="email" type="email" placeholder="" name="email" autofocus="autofocus" :disabled="isLoading" class="font-clean-text"
                                        style="border-radius: 5px;margin-top: 0px;color: #191d23b3 !important;font-weight: 500;font-size: 16px !important;"/>
                                    </div>

                                    <div class="form-group">
                                        <label class="font-clean-label" style="margin-top: 15px;margin-bottom: 0px;" for="browser_first_name">Contraseña</label>
                                        <b-form-input required v-model="password" type="password" name="password" class="font-clean-text"
                                        :disabled="isLoading" style="margin-top: 0px;border-radius: 5px;font-size: 16px;font-weight: 500;color: #191d23b3 !important;"/>
                                    </div>

                                    <b-form-checkbox id="checkbox-1" v-model="keep_signed" name="checkbox-1" class="font-clean-label"
                                        value="1" unchecked-value="0" :disabled="isLoading" style="margin-top: 40px;text-align: -webkit-center;color: #191d23b3 !important;">
                                        Mantenerme conectado
                                    </b-form-checkbox>

                                    <!--<div class="form-group">
                                        <label class="font-clean-label" style="margin-top: 30px;margin-bottom: 0px;" for="browser_first_name">Usuario</label>
                                        <b-form-input required v-model="userid" type="text" placeholder="" name="userid" :disabled="isLoading" class="font-clean-text"
                                        style="border-radius: 5px;margin-top: 0px;color: #191d23b3 !important;font-weight: 500;font-size: 16px !important;font-weight: bold;"/>
                                    </div>-->

                                    <button v-if="!isLoading" class="btn btn-block font-clean-text btn-login-color" type="submit" :disabled="isLoading" 
                                        style="border-radius: 5px;margin-top: 30px;color: white;">Ingresar
                                    </button>
                                    <button v-if="isLoading" class="btn btn-block font-clean-text btn-login-color" style="margin-top: 30px;" disabled>
                                        <b-spinner small style="margin-right:5px;color: white;"></b-spinner>Cargando...
                                    </button>
                                </form>

                                <a href="#" 
                                    style="display: block;text-align: center;"
                                    @click="forgot_password()" :disabled="isLoading">Olvidé mi contraseña</a>
                                <br/>

                                <span class="font-clean-text" style="display: block;text-align: center;">&copy; {{ new Date().getFullYear() }} - Sad Corp S.A.C.</span>
                            </div>
                        </div>
                        
                    </b-row>
            </b-col>

        </b-row>
            
    </b-container>

</template>

<script>

export default {
    name: 'login',
    data() {
        return {
            email: '',
            password: '',
            keep_signed: 0,
            isLoading: false
        }
    },
    methods: {
        signUp: function () {

            this.isLoading = true;

            if (this.email == "" && this.password == '') {
                this.showError("Debe ingresar un email y contraseña válidos")
                this.isLoading = false;
            } else {

                try {
                    this.$http.plain.post('/auth/v1/login', { email: this.email, password: this.password, keep_signed: this.keep_signed })
                    .then(response => this.signinSuccessful(response))
                    .catch(error => this.signinFailed(error))                    
                } catch (err) {
                    this.isLoading = false;
                    this.showError(err)
                }
            }
        },
        signinSuccessful (response) {
            if (!response.data.csrf) {
                this.signinFailed(response)
                return
            }
            
            this.isLoading = false;

            var host = window.location.host;
            var parts = host.split('.');
            var res_data = {
                csrf: response.data.csrf,
                user: response.data.user
            }
            localStorage.avatar = response.data.avatar

            window.location.href = window.location.protocol + "//" + response.data.user.environment_name + "." + parts[parts.length-3] + "." + parts[parts.length-2] + "." + parts[parts.length-1] + "/auth/login_from_token/" + window.btoa(JSON.stringify(res_data))    
            //window.location.href = "http://192.168.0.171:8080/auth/login_from_token/" + window.btoa(JSON.stringify(response.data))        
        },
        signinFailed (error) {

            var e = '';
            if(error){
            if(error.data){
                if(error.data.error){
                e = error.data.error;
                } else{
                e = error.data;
                }   
            }else{
                e = error;
            }
            }else{
            e = 'error';
            }
            
            localStorage.clear()

            this.showError(e)
            this.isLoading = false;
            
        },
        register () {
            this.isLoading = false;
            this.$router.push('/auth/register_step_one/')
        },
        forgot_password () {
            this.isLoading = true;

            if (this.email == "") {
                this.showError("Debe ingresar un email")
                this.isLoading = false;
            } else {

                try {
                    this.$http.plain.post('/auth/v1/login', { type: 'forgot_password', platform: "desk", email: this.email })
                    .then(response => this.forgotPasswordSuccessful(response))
                    .catch(error => this.forgotPasswordFailed(error))                    
                } catch (err) {
                    this.isLoading = false;
                    this.showError(err)
                }
            }
        },
        forgotPasswordSuccessful (response) {
            this.$router.push('/auth/register_step_three/' + window.btoa(this.email))
        },
        forgotPasswordFailed (error) {

            var e = '';
            if(error){
            if(error.data){
                if(error.data.error){
                e = error.data.error;
                } else{
                e = error.data;
                }   
            }else{
                e = error;
            }
            }else{
            e = 'error';
            }
            
            localStorage.clear()

            this.showError(e)
            this.isLoading = false;
            
        },

    }
}
</script>